import PageNotFound from "../Components/Layout/PageNotFound";
import ChangePassword from "../Page/ChangePassword";
import MainDashboard from "../Page/Dashboard/MainDashboard";
import Login from "../Page/Login";
import Personaldetails from "../Page/Personaldetails";
import Register from "../Page/Register";
import Resetpassword from "../Page/ResetPassword";

import Comingpage from "../Components/Layout/Comingpage";

export const CommonRoutes = [
  {
    path: "/",
    Component: <Login />,
    Title: "login",
  },
  {
    path: "/register",
    Component: <Register />,
    Title: "Register",
  },
  {
    path: "/maindashboard",
    Component: <MainDashboard />,
    Title: "MainDashboard",
  },
  {
    path: "/personaldetails",
    Component: <Personaldetails />,
    Title: "Personaldetails",
  },
  {
    path: "/resetpassword",
    Component: <Resetpassword />,
    Title: "ResetPassword",
  },
  {
    path: "/changepassword",
    Component: <ChangePassword />,
    Title: "ChangePassword",
  },
  {
    path: "*",
    Component: <PageNotFound />,
    Title: "PageNotFound",
  },
  {
    path: "/comingpage",
    Component: <Comingpage />,
    Title: "Comingpage",
  },
];
